"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Pin = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.95408901,15.7027652 L5.86574988,18.8526534 C5.67432172,19.0478966 5.36086261,19.0509893 5.16561938,18.8595612 L5.16214845,18.8561243 C4.96632461,18.6603005 4.96476084,18.343293 5.15864323,18.1455467 L8.24711419,14.9955265 L4.75,11.4971067 L5.32651843,10.857272 C6.39181091,9.67498359 7.90856855,9 9.5,9 L11.25,9 L13,7.25 L13,6.49264069 C13,5.69699122 13.3160705,4.93392948 13.8786797,4.37132034 L14.5,3.75 L20.25,9.5 L19.6286797,10.1213203 C19.0660705,10.6839295 18.3030088,11 17.5073593,11 L16.75,11 L15,12.75 L15,14.5 C15,16.0913249 14.3245871,17.6078716 13.1417646,18.6724118 L12.5,19.25 L8.95408901,15.7027652 Z M14,7.75 L11.75,10 L9.45256242,10 C8.21534601,10 7.04204664,10.549544 6.25,11.5 L12.5,17.75 C13.450456,16.9579534 14,15.784654 14,14.5474376 L14,12.25 L16.25,10 L17.5428932,10 C17.9956461,10 18.4298554,9.82014462 18.75,9.5 L14.5,5.25 C14.1798554,5.57014462 14,6.00435391 14,6.45710678 L14,7.75 Z" })));
};
Pin.displayName = 'Pin';
exports.default = Pin;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Pin.js.map